export enum SetSearchTypes {
  DRIVER = 'DRIVER',
  PASSENGER = 'PASSENGER',
  SET = 'SET'
}
